/* eslint-disable */
const ls = require('local-storage');

import services from 'services';
import jwtDecode from 'jwt-decode';
import * as types from './mutation-types';

export default {
  fetchState: ({ dispatch }) => {
    const shopToken = ls.get('shopToken');
    if (shopToken) {
      dispatch('loginWithShopToken', shopToken);
      return shopToken;
    }
    return null;
  },
  loginWithShopToken: async ({ commit }, shopToken) => {
    commit(types.LOGIN, {
      shop: jwtDecode(shopToken),
      shopToken: shopToken
    });
  },
  /**
   * Adds shop to state and set state.authenticated value to true
   */
  handleMagicLinkToken: async ({ commit, dispatch, rootGetters }, token) => {
    try {
      await services.ShopAuthService.loginWithMagicLinkToken(token);
      dispatch('loginWithShopToken', token);
    } catch {
      throw new Error('ShopTokenError');
    }
  },
  getShopName: async ({ commit }, shopId) => {
    try {
      const res = await services.ShopAuthService.getShopName(shopId);
      commit('shopName', res);
    } catch (e) {
      throw new Error(e);
    }
  },
  getShopInfo: async ({ commit }, shopId) => {
    try {
      const res = await services.ShopAuthService.getShopInfo(shopId);
      commit(types.INFO_SHOP, res);
    } catch (e) {
      throw new Error(e);
    }
  },
  logout: ({ commit, dispatch }) => {
    commit(types.RESET);
  },
};
